import qs from 'qs';
import {webConfig} from '@/services/web-config.state';

export const PATH = {
  // invite: '/invite',
  invite: '/home',
  default: '/home',
};
export const getUrl = (path: string, params: Record<string, string>) => {
  const baseUrl = webConfig.scratchUrl;
  if (!baseUrl) {
    return '';
  }

  const queryString = qs.stringify(params);
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${normalizedPath}${queryString ? `?${queryString}` : ''}`;
};

export const enum EventType {
  LOGIN = 'login',
  BACK = 'back',
  EXIT = 'exit',
  SHARE = 'share',
  DOWNLOAD_APP = 'downloadApp',
}
